import React from "react";

function Arrow() {
  return (
    <>
      <svg
        width={24}
        height={25}
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M19 11.0343H7.14L10.77 6.67433C10.9397 6.47012 11.0214 6.20684 10.997 5.94241C10.9726 5.67798 10.8442 5.43407 10.64 5.26433C10.4358 5.09459 10.1725 5.01293 9.90808 5.03731C9.64365 5.06169 9.39974 5.19012 9.23 5.39433L4.23 11.3943C4.19636 11.4421 4.16628 11.4922 4.14 11.5443C4.14 11.5943 4.14 11.6243 4.07 11.6743C4.02467 11.789 4.00094 11.911 4 12.0343C4.00094 12.1576 4.02467 12.2797 4.07 12.3943C4.07 12.4443 4.07 12.4743 4.14 12.5243C4.16628 12.5765 4.19636 12.6266 4.23 12.6743L9.23 18.6743C9.32402 18.7872 9.44176 18.878 9.57485 18.9402C9.70793 19.0024 9.85309 19.0346 10 19.0343C10.2337 19.0348 10.4601 18.9534 10.64 18.8043C10.7413 18.7204 10.825 18.6173 10.8863 18.5009C10.9477 18.3846 10.9855 18.2573 10.9975 18.1263C11.0096 17.9953 10.9957 17.8633 10.9567 17.7377C10.9176 17.612 10.8542 17.4954 10.77 17.3943L7.14 13.0343H19C19.2652 13.0343 19.5196 12.929 19.7071 12.7414C19.8946 12.5539 20 12.2995 20 12.0343C20 11.7691 19.8946 11.5148 19.7071 11.3272C19.5196 11.1397 19.2652 11.0343 19 11.0343Z"
          fill="url(#paint0_linear)"
        />
        <defs>
          <linearGradient
            id="paint0_linear"
            x1={12}
            y1="5.03308"
            x2={12}
            y2="19.0343"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#EC8D1D" />
            <stop offset={1} stopColor="#511A79" />
          </linearGradient>
        </defs>
      </svg>
    </>
  );
}

export { Arrow };
